import {AxiosRequestConfig} from 'axios';
import request from '../../axios';

interface IStoreAdsProps {
  status_list?: string;
  order_by?: string;
  advertisement_type?: string;
  search?: string;
  store_guid?: string;
  ad_type?: string;
}
export const getStoreAds = async (
  pageNumber: number,
  props: IStoreAdsProps = {},
) => {
  const {status_list, order_by, advertisement_type, search, ad_type} = props;

  const payload =
    {
      status_list,
      order_by,
      advertisement_type,
      ad_type,
      search,
    } ?? {};

  const {data}: {data: IStoreAds} = await request.get(
    `api/v2/store/user-store-ads`,
    {
      params: {...payload, page: pageNumber},
    } as AxiosRequestConfig,
  );

  return data;
};
